import React, { useState, useEffect, useRef } from 'react';

function Sandbox() {
  const [inputValue, setInputValue] = useState('');
  const [messages, setMessages] = useState([]);
  const [chatMode, setChatMode] = useState('normal'); // Default chat mode
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [recordedChunks, setRecordedChunks] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const audioRef = useRef(null);

  const suggestedResponses = ['Option 1', 'Option 2', 'Option 3'];

  useEffect(() => {
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((stream) => {
        const mediaRecorder = new MediaRecorder(stream);
        setMediaRecorder(mediaRecorder);

        mediaRecorder.ondataavailable = (event) => {
          setRecordedChunks((prevChunks) => [...prevChunks, event.data]);
        };

        mediaRecorder.onstop = () => {
          const audioBlob = new Blob(recordedChunks, { type: 'audio/wav' });
          const audioUrl = URL.createObjectURL(audioBlob);

          const newMessage = { audio: audioUrl, isBot: false };
          setMessages((prevMessages) => [...prevMessages, newMessage]);

          setRecordedChunks([]);
        };
      })
      .catch((error) => {
        console.error('Error accessing microphone:', error);
      });
  }, []);

  function handleInputChange(event) {
    setInputValue(event.target.value);
  }

  function handleSendMessage(event) {
    event.preventDefault();

    if (inputValue.trim() !== '') {
      const newMessage = { text: inputValue, isBot: false };
      setMessages((prevMessages) => [...prevMessages, newMessage]);

      // Call your chat bot API here and add the response to the messages state.
      // For example:
      // fetch('your-chat-bot-api-url', {
      //   method: 'POST',
      //   body: JSON.stringify({ message: inputValue }),
      //   headers: {
      //     'Content-Type': 'application/json'
      //   }
      // }).then(response => response.json())
      //   .then(data => {
      //     const botMessage = { text: data.message, isBot: true };
      //     setMessages([...messages, botMessage]);
      //   });

      setInputValue('');
    }
  }

  function handleChatModeChange(event) {
    setChatMode(event.target.value);
  }

  function handleButtonClicked(buttonText) {
    const newMessage = { text: buttonText, isBot: false };
    setMessages((prevMessages) => [...prevMessages, newMessage]);

    // Call your chat bot API here if needed for button-specific actions.
  }

  function startRecording() {
    setIsRecording(true);
    mediaRecorder.start();
  }

  function stopRecording() {
    setIsRecording(false);
    mediaRecorder.stop();
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', maxWidth: '400px', margin: '0 auto' }}>
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {messages.map((message, index) => (
          <div
            key={index}
            style={{
              alignSelf: message.isBot ? 'flex-start' : 'flex-end',
              backgroundColor: message.isBot ? '#EEE' : '#0084ff',
              borderRadius: '5px',
              color: message.isBot ? '#000' : '#FFF',
              margin: '10px',
              maxWidth: '60%',
              padding: '10px',
              wordWrap: 'break-word',
            }}
          >
            {message.text && <p>{message.text}</p>}
            {message.audio && (
              <audio controls ref={audioRef}>
                <source src={message.audio} type="audio/wav" />
                Your browser does not support the audio element.
              </audio>
            )}
          </div>
        ))}
      </div>
      <form onSubmit={handleSendMessage} style={{ display: 'flex', marginBottom: '20px' }}>
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          style={{ flex: 1, marginRight: '10px', padding: '10px' }}
        />
        <button type="submit" style={{ padding: '10px' }}>Send</button>
      </form>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
        {isRecording ? (
          <button onClick={stopRecording} style={{ marginRight: '10px', background: 'red', color: 'white' }}>
            Stop Recording
          </button>
        ) : (
          <button onClick={startRecording} style={{ marginRight: '10px' }}>
            Start Recording
          </button>
        )}
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {suggestedResponses.map((response, index) => (
          <button
            key={index}
            onClick={() => handleButtonClicked(response)}
            style={{ marginRight: '10px' }}
          >
            {response}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Sandbox;
